// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"a94ac775","355":"1cd0a12e"}[chunkId] + ".chunk.js";
};